import React, { useEffect, useState } from "react";
import TextInput from "../../../../components/Input/TextInput";
import { ActionIcon, Box, Center, SimpleGrid, Text } from "@mantine/core";
import { Button } from "../../../../components/Button/Button";
import { X } from "tabler-icons-react";

const AccessoriesDropdown = ({ form }) => {
  const [rows, setRows] = useState(
    form?.values?.accessories.length
      ? form?.values?.accessories
      : Array.from({ length: 4 }, () => ({
          description: "",
          price: "",
          cost: "",
          id: Math.random(),
        })),
  );

  const addRow = () => {
    setRows([
      ...rows,
      {
        description: "",
        price: "",
        cost: "",
        id: Math.random(),
      },
    ]);
  };

  useEffect(() => {
    const accessoriesPrice = rows.reduce((acc, row) => acc + ((row.price && parseFloat(row.price)) || 0), 0);
    const accessoriesCost = rows.reduce((acc, row) => acc + ((row.cost && parseFloat(row.cost)) || 0), 0);
    console.log("accessoriesPrice", accessoriesPrice);
    console.log("accessoriesCost", accessoriesCost);

    form.setFieldValue("accessoriesPrice", accessoriesPrice);
    form.setFieldValue("accessoriesCost", accessoriesCost);
  }, [rows]);

  const removeRow = (id) => {
    console.log("Rows before", rows);
    // Remove the row from the array but also retain the data as it is
    const newRows = rows.filter((row) => row.id !== id);
    console.log("Rows after", newRows);
    setRows(newRows);

    // Remove the row from the form
    form.setFieldValue("accessories", newRows);
  };

  return (
    <>
      <SimpleGrid cols={4} spacing={5}>
        <Text fz={"sm"}>Description</Text>
        <Text fz={"sm"}>Price</Text>
        <Text fz={"sm"}>Cost</Text>
        <Text fz={"sm"} align="center">
          Cancel
        </Text>
        {rows.map((_, i) => (
          <>
            <TextInput
              key={i + "description"}
              value={rows[i].description}
              placeholder="Description"
              onChange={(e) => {
                const newRows = [...rows];
                newRows[i].description = e.target.value;
                setRows(newRows);
                form.setFieldValue("accessories", newRows);
              }}
              size="xs"
            />
            <TextInput
              key={i + "price"}
              value={rows[i].price}
              placeholder="Price"
              onChange={(e) => {
                const newRows = [...rows];
                newRows[i].price = e.target.value;
                setRows(newRows);
                form.setFieldValue("accessories", newRows);
              }}
              type="number"
              size="xs"
            />
            <TextInput
              key={i + "cost"}
              value={rows[i].cost}
              placeholder="Cost"
              onChange={(e) => {
                const newRows = [...rows];
                newRows[i].cost = e.target.value;
                setRows(newRows);
                form.setFieldValue("accessories", newRows);
              }}
              type="number"
              size="xs"
            />
            <Center>
              <ActionIcon onClick={() => removeRow(rows[i].id)}>
                <X color="red" />
              </ActionIcon>
            </Center>
          </>
        ))}
      </SimpleGrid>
      <Button size="xs" onClick={addRow}>
        Add
      </Button>
    </>
  );
};

export default AccessoriesDropdown;
